import script from "./SearchOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./SearchOverlay.vue?vue&type=style&index=0&id=0f1e81c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1e81c8"]])

export default __exports__